// src/components/PostLoginRouteSettled.js
//
// Lowers AuthContext's postLoginInProgress flag once the router is off
// /login. The flag stops the /login route guard from redirecting a user who
// has just signed in while resumePostLogin is still picking where they go.
// resumePostLogin used to lower it itself, straight after navigate(): the
// guard then rendered once more on /login, saw a signed-in user and no flag,
// and replaced the destination with /tasks or the workspace picker. A user
// with a forced password reset never saw the reset page (found 2026-10-08).
// Rendered once, inside the router.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PostLoginRouteSettled() {
  const { postLoginInProgress, setPostLoginInProgress } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    if (postLoginInProgress && pathname !== '/login') {
      setPostLoginInProgress(false);
    }
  }, [postLoginInProgress, pathname, setPostLoginInProgress]);

  return null;
}
